import { css } from '@emotion/react'
import { graphql, useStaticQuery } from 'gatsby'
import {
  ComponentPropsWithoutRef,
  Dispatch,
  SetStateAction,
} from 'react'

import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

export interface DivisionFilterData {
  id: string
  divisionName: string
}

interface Props extends ComponentPropsWithoutRef<'div'> {
  activeFilter: DivisionFilterData | undefined
  setActiveFilter: Dispatch<
    SetStateAction<DivisionFilterData | undefined>
  >
  allLabel?: string
}

export const DivisionFilter = ({
  activeFilter,
  setActiveFilter,
  allLabel,
  ...props
}: Props): JSX.Element => {
  interface QueryProps {
    allDatoCmsDivisionPage: {
      nodes: {
        id: string
        divisionName: string
      }[]
    }
  }
  const { allDatoCmsDivisionPage } = useStaticQuery<QueryProps>(graphql`
    query DivisionFilter {
      allDatoCmsDivisionPage(sort: { divisionName: ASC }) {
        nodes {
          id: originalId
          divisionName
        }
      }
    }
  `)
  const filters = allDatoCmsDivisionPage.nodes
  const styles = {
    container: css`
      display: flex;
      width: 100%;
      background: ${colors.gray10};
      padding: 2px;
      gap: 2px;
      margin-bottom: 2em;
      flex-wrap: wrap;
    `,
    button: css`
      flex: 1;
      flex-basis: 21%;
      color: ${colors.gray10};
      background: #fff;
      font-size: var(--fs-21);
      text-transform: uppercase;
      padding: 0.5em;
      @media (hover: hover) {
        &:hover {
          background: ${colors.gray95};
          color: ${colors.red};
        }
      }
      ${mq().s} {
        font-size: var(--fs-15);
        font-weight: 500;
        flex-basis: 34%;
      }
    `,
    activeButton: css`
      color: #fff;
      background: ${colors.gray10};
      pointer-events: none;
    `,
  }
  return (
    <div
      css={styles.container}
      {...props}
    >
      {allLabel && (
        <button
          css={[styles.button, !activeFilter && styles.activeButton]}
          onClick={() => setActiveFilter(undefined)}
        >
          {allLabel}
        </button>
      )}
      {filters.map(filter => (
        <button
          css={[
            styles.button,
            filter.id === activeFilter?.id && styles.activeButton,
          ]}
          onClick={() => setActiveFilter(filter)}
          key={filter.id}
        >
          {filter.divisionName}
        </button>
      ))}
    </div>
  )
}
